module.exports = __webpack_public_path__ + "static/media/link.059d7914.svg";